import React, { Component } from 'react';
import Footer from "./footer";
import Menu from "./menu";
import jQuery from 'jquery';
import {executaEntreIntervaloMinimo} from '../modules/util';


class Master extends Component {


    constructor(props) {
        super(props);
        this.state = {
            classMenu: "",
            ativo: false
        };
    }


    componentDidMount() {
        var that = this;

        jQuery(window).on("scroll.menutop", executaEntreIntervaloMinimo(function () {
            var pos = jQuery(window).scrollTop();
            var ativo = pos > 100;
            if (that.state.ativo != ativo) {
                that.setState({
                    ativo: ativo
                });
            }
        }, 30));
    }


    componentWillUnmount() {
        jQuery(window).off("scroll.menutop");
    }

    abreFecha() {
        this.setState({
            classMenu: this.state.classMenu ? "" : "aberto"
        });

    }

    onClickItem(e) {

        this.abreFecha();

    }

    onAbreMenu(e) {
        e.preventDefault();
        this.abreFecha();
    }

    render() {
        return (
            <div>
                <div className={this.state.classMenu + " menuAbre"} onClick={this.onAbreMenu.bind(this)}><i className="material-icons" >{(this.state.classMenu ? "close" : "menu")}</i></div>
                <header className={this.state.classMenu + " header-menu " + (this.state.ativo ? " menu-ativo" : "")} >
                    <Menu onClickItem={this.onClickItem.bind(this)} />
                </header>
                <main className="">
                    <div className="">
                        {this.props.children}
                    </div>
                </main>
                <Footer />
            </div>
        );
    }
};

export default Master;
